/**
 * @generated SignedSource<<dffe753ec8b3e015549cad7775fc9e8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NounResolvedLinkFragment$data = {
  readonly address: string;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"NounResolvedNameFragment">;
  readonly " $fragmentType": "NounResolvedLinkFragment";
};
export type NounResolvedLinkFragment$key = {
  readonly " $data"?: NounResolvedLinkFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NounResolvedLinkFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NounResolvedLinkFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NounResolvedNameFragment"
    }
  ],
  "type": "ResolvedName",
  "abstractKey": null
};

(node as any).hash = "3df2d0293fb4b231ba8c67716b093510";

export default node;
